import {TimelineLite} from "gsap";
import {PearlHarbor} from "../PearlHarbor";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";
import {ISplitData, ISymbolData} from "../server/PearlHarborModel";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {PearlHarborSymbol} from "./PearlHarborSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class PearlHarborSplitSymbol extends PearlHarborSymbol {
    private readonly directionName: string[] = ["up", "down", "left", "right"];
    public readonly animationConfig = {"add_sword": 19, "landing": 13, "split": 30, "turningWild": 22};

    private _dirs: boolean[];
    private _currentDirs: number[] = [];
    private _landingAnimation: PIXI.spine.Spine;
    private _isWild: boolean;
    private _hasSplit: boolean;
    private _extraSwordAnimations: PIXI.spine.Spine[];

    constructor(symbolData: ISymbolData) {
        super(symbolData);
        this._dirs = [];
        this._isWild = false;
        this._hasSplit = false;
        this._currentDirs = [];
        this._extraSwordAnimations = [];
    }

    public playXSLandingAnim(isRestore:boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (this._isWild) {
            return tl;
        }

        if (isRestore) {
            this._landingAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`XS${this._isSplit ? "_H" : ""}`));
            this._landingAnimation.name = "landingAnimation";
            this._isWild = true;
            this._hasSplit = true;
            this.addChild(this._landingAnimation);
            this._name = `X_SPLIT_SPENT${this._isSplit ? "_H" : ""}`;
            this.currentStateSprite.texture = PearlHarbor.assetLoader.getTextures(`${this._name}/${this._name}`)[0];
            return tl;
        }

        this._isWild = true;
        this._hasSplit = false;
        this._dirs = [];
        const xsData: ISplitData[] = PearlHarbor.model.isRestore ? PearlHarbor.model.xs : PearlHarbor.model.xsLanding;
        this._landingAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`XS${this._isSplit ? "_H" : ""}`));
        this._landingAnimation.name = "landingAnimation";
        this.addChild(this._landingAnimation);
        this.removeChild(this._sizeMultiplier);
        this._landingAnimation.position.set(0, 0);
        const spineTweens: SpineTween[] = [];
        let trackId: number = 0;
        xsData.forEach((xs: ISplitData) => {
            if (xs.symPos[0] === this._reelId && xs.symPos[1] === this.reelTargetPosition) {
                this._dirs = xs.dir;
                xs.dir.forEach((hasSplit: boolean, i: number) => {
                    if (hasSplit) {
                        this._currentDirs.push(i);
                        spineTweens.push(new SpineTween(this._landingAnimation, trackId, `land_${this.directionName[i]}`));
                        trackId++;
                    }
                })

            }
        });
        if (this._dirs.length === 0) {
            Logger.logDev(`${this._reelTargetPosition}, ${PearlHarbor.model.xsLanding} has no directions data`);
        }
        if (trackId < 2) {
            spineTweens.push(new SpineTween(this._landingAnimation, 4, `single`));
        }
        tl.add(spineTweens, 0);
        tl.add(() => {
            PearlHarborSoundManager.playXSLandingSound();
        }, 0);

        //remove this line because #86
        //PearlHarbor.allReelsView.landingTLs.push(tl);
        return tl;
    }

    private checkIsTowardsWall(i: number): boolean {
        if (this._onReelId === 0 && i === 0) {
            return true;
        }


        if ((i === 1) && (this._onReelId + 1) === PearlHarbor.allReelsView.mainReelModels[this._reelId].getAllSymbols().length) {
            return true;
        }

        if (this._reelId === 0 && i === 2) {
            return true;
        }

        if (this._reelId === 6 && i === 3) {
            return true;
        }
        return false;
    }

    public playSplitAnim(): TimelineLite {
        this._isWild = true;
        this._hasSplit = true;
        this._name = `X_SPLIT_SPENT${this._isSplit ? "_H" : ""}`;
        const tl: TimelineLite = new TimelineLite(),
            animationStartTime: number = 0.1;
        let hasSplitAnimation: boolean = false,
            trackId: number = 0;
        const spineTweens: SpineTween[] = [];
        NolimitApplication.getLayerByName("XSplitAnimation")!.addChild(this._landingAnimation);
        this._landingAnimation.position.set((this._reelId) * PearlHarborGameConfig.symbolWidth, (this._reelTargetPosition + 1) * PearlHarborGameConfig.symbolHeight * 0.5-(this._isSplit?24:0));
        this.removeChild(this._landingAnimation);
        this._dirs.forEach((dir: boolean, i: number) => {
            if (dir) {
                hasSplitAnimation = true;
                if (!this.checkIsTowardsWall(i)) {
                    trackId++;
                    spineTweens.push(new SpineTween(this._landingAnimation, i, `split_${this.directionName[i]}`));
                }
            }
        });

        if (hasSplitAnimation) {
            tl.add(spineTweens, animationStartTime);
            //tl.add(()=>{this._landingAnimation.state.clearTrack(4)}, animationStartTime+0.1);
            tl.add(() => {
                PearlHarborSoundManager.playXSSplitSound();
            }, animationStartTime);
            tl.add(() => {
                this.currentStateSprite.texture = PearlHarbor.assetLoader.getTextures(`${this._name}/${this._name}`)[0];
                NolimitApplication.getLayerByName("XSplitAnimation")!.removeChild(this._landingAnimation)
            });
        }

        tl.add(() => {
            this.updateMultiplier();
            NolimitApplication.getLayerByName("XSplitAnimation")!.removeChild(this._landingAnimation);
        });
        return tl;
    }

    public updateMultiplier(id?: number): TimelineLite {
        if (!this._hasSplit) {
            for (let key in PearlHarbor.model.data.xsplitsMultipliers) {
                let value: number = PearlHarbor.model.data.xsplitsMultipliers[key];

                if ((this.reelId * 14 + this._reelTargetPosition).toString() === key) {
                    this.sizeMultiplier = value / 4;
                }
            }
        } else {
            this.sizeMultiplier = PearlHarbor.model.gameData.allSizesBeforeCollapse[this._reelId][this._onReelId];
        }

        this._sizeMultiplier.visible = (this.sizeMultiplier > 1);
        this.addChild(this._sizeMultiplier);
        return new TimelineLite();
    }

    private getToAddSwordDir(): boolean[] {
        let newDir: boolean[] = [];

        PearlHarbor.model.xs.forEach((splitData: ISplitData) => {
            if (splitData.symPos[0] === this._reelId && splitData.symPos[1] === this.reelTargetPosition) {
                newDir = splitData.dir.concat();
                this._sizeMultiplier.text = "x" + (splitData.multi < 4 ? splitData.multi : (Math.floor(splitData.multi / 4))).toString();
                if (splitData.multi > 4 && (splitData.multi % 4 !== 0)) {
                    debugger;
                }
            }
        });
        const swordNum: number = newDir.filter(dir => dir === true).length;
        if (swordNum < 2) {
            return [];
        }
        return newDir;
    }

    public addSword(): TimelineLite {
        const newDir: boolean[] = this.getToAddSwordDir();
        if (newDir.length < 1) {
            return new TimelineLite();
        }
        const tl: TimelineLite = new TimelineLite();
        this._landingAnimation.state.clearTrack(4);
        this._landingAnimation.skeleton.setToSetupPose();
        newDir.forEach((dir: boolean, i: number) => {
            if (dir) {
                this._landingAnimation.state.setAnimation(i, `land_${this.directionName[i]}`, false);
                if (!this._dirs[i]) {
                    this._dirs[i] = true;
                    tl.add(new SpineTween(this._landingAnimation, i, `add_sword_${this.directionName[i]}`));
                }
            }
        });
        tl.add(() => {
            this.updateMultiplier();
        });

        return tl;
    }

    public remove() {
        if(this._landingAnimation){
            this._landingAnimation.destroy();
        }
        super.remove();
    }
}